import { useSession } from "./SessionProvider.tsx";
import { useIsGracePeriod } from "./useIsGracePeriod.ts";

// A Protect subscription is "active" when it's genuinely valid, or expired but still within its
// grace period. The backend always includes the subscription once one exists, even long past
// retention (post-retention/data-deleted state, out of scope here — a separate story) — this is
// the single place that decides whether that counts as real access. For the raw subscription data
// (badge, endDate, isTrial), read session.products?.protect.subscription directly instead.
export function useIsProtectActive(): boolean {
    const session = useSession();
    const isGracePeriod = useIsGracePeriod();
    const subscription = session.products?.protect.subscription;

    return subscription != null && (subscription.isValid || isGracePeriod);
}
